import React from 'react';
import { useTranslation } from 'react-i18next';
import rightArrow from "../../assets/images/rightArrow.svg";
import { routePath } from '../../constants/Routes';

const MyPlan = (props) => {
  const { moveToEditPage, paymentCardNumber } = props;
  const { t } = useTranslation(["translation"]);

  return (
    <>
      {paymentCardNumber &&
        <div className="row my-account-content plan-border" id="my-plan">
          <div className="f-16 fc-g fw-b ta-left mb-30">
            {t("SIGN_UP_FEEDBACK.ISSUES_LIST.PAYMENT_DETAILS")}
          </div>

          <div
            className="row pointer-cursor"
            onClick={() => moveToEditPage(routePath.EDIT_ACCOUNT, "paymentDetails")}
          >
            <div className="col-10 mt-15">
              <div className="plan-type-header">
                {t("DASHBOARD.MY_ACCOUNT_LANDING.PAYMENT_TYPE")}
              </div>
              <div className="plan-occasional">
                {paymentCardNumber}
              </div>
            </div>
            <div className="col my-account-edit-btn mt-15">
              <img src={rightArrow} alt="edit billing address" />
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default MyPlan;